/** The few endpoints the sign-in screens call through `HelperService`. */
export const GET_METHOD = {
    GET_SETTINGS: 'api/getSettingsForHeroes',
    GET_ASSOCIATED_ENTITIES: 'api/heroes/getAssociatedEntities'
};

export const POST_METHOD = {
    ADD_ENTITY: 'api/heroes/addEntity',
    SEND_OTP: 'api/sendOtp',
    VERIFY_OTP: 'api/verifyOtp',
    VERIFY_MPIN: 'api/verifyMPin',
    RESET_MPIN: 'api/resetMPin'
};
